import apiEndpoints from 'api/endpoints';

import { baseAPI } from './baseApi';

export const usersApi = baseAPI.injectEndpoints({
    endpoints: (builder) => ({
        getUsers: builder.query({
            query: ({ companyAccessCode, limit, offset, order = 'newest' }) => ({
                url: apiEndpoints.users,
                method: 'POST',
                body: {
                    companyAccessCode,
                    limit,
                    offset,
                    order,
                },
            }),
            providesTags: ['Users'],
        }),

        searchUsers: builder.query({
            query: (body) => ({
                url: apiEndpoints.userFilter,
                method: 'POST',
                body,
            }),
            providesTags: ['Users'],
        }),

        createUser: builder.mutation({
            query: (userInfo) => ({
                url: apiEndpoints.createUser,
                method: 'POST',
                body: userInfo,
            }),
            invalidatesTags: ['Users'],
        }),

        provideConsent: builder.mutation({
            query: ({ userAccessCode, fullName }) => ({
                url: apiEndpoints.consent,
                method: 'POST',
                body: {
                    userAccessCode,
                    isBackgroundDisclosureAccepted: 1,
                    GLBPurposeAndDPPAPurpose: 1,
                    FCRAPurpose: 1,
                    fullName,
                },
            }),
        }),

        sendLinkViaEmail: builder.mutation({
            query: (body) => ({
                url: apiEndpoints.sendEmailViaLink,
                method: 'POST',
                body,
                responseHandler: async (response) => {
                    const text = await response.text();
                    if (!text) return {};
                    try {
                        return JSON.parse(text);
                    } catch {
                        return text;
                    }
                },
            }),
        }),
    }),
});

export const {
    useGetUsersQuery,
    useLazyGetUsersQuery,
    useLazySearchUsersQuery,
    useCreateUserMutation: useCreateUser,
    useProvideConsentMutation: useProvideConsent,
    useSendLinkViaEmailMutation: useSendLinkViaEmail,
} = usersApi;

export default usersApi.middleware;
